import React, { useState } from 'react';
import './AddDevice.css';
import FilterDropdown from './FilterDropdown';
import { toast } from 'react-toastify';

export default function AddDevice({ onAdded }) {
  const [imei, setImei] = useState('');
  const [name, setName] = useState('');
  const [type, setType] = useState('vehicle');
  const [loading, setLoading] = useState(false);

  const username = localStorage.getItem('authUser') || '';

  //  API
  const PROD_URL = process.env.REACT_APP_POST_DEVICE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY || "";

  // Automatically switch API base URL by environment.
  const postUrl =
    process.env.NODE_ENV === "production"
      ? PROD_URL
      : "http://localhost:3000/test_app/get_gen_tab?TableName=TabDeviceDetails";

  function validate() {
    if (!imei || !/^[0-9]+$/.test(imei)) {
      toast.error('IMEI must be numeric');
      return false;
    }
    if (!name) {
      toast.error('Device name required');
      return false;
    }
    if (!type) {
      toast.error('Select device type');
      return false;
    }
    return true;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    try {
      const payload = {
        username,
        imei: String(imei),
        deviceName: name,
        deviceType: type,
      };

      const res = await fetch(postUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(API_KEY && { "x-api-key": API_KEY }),
        },
        body: JSON.stringify(payload),
      });

      // Avoid crashing if response is not valid JSON
      const responseText = await res.text();
      let jsonResponse;
      try {
        jsonResponse = JSON.parse(responseText);
      } catch {
        throw new Error("Invalid response from server (HTML instead of JSON). Check API URL & CORS settings.");
      }

      console.log("API Response:", res.status, jsonResponse);

      if (res.ok) {
        toast.success("Device added successfully");
        const created = { imei, deviceName: name, deviceType: type };
        window.lastAddedDevice = created;
        setImei("");
        setName("");
        setType("vehicle");

        if (onAdded) onAdded(created);
      } else if (res.status === 409 || (jsonResponse.message && jsonResponse.message.toLowerCase().includes("already"))) {
        toast.info("Device already linked. Refreshing...");
        if (onAdded) onAdded({ imei, deviceName: name, deviceType: type });
      } else {
        toast.error(jsonResponse.message || "Failed to add device");
      }

    } catch (err) {
      console.error("Error:", err);
      toast.error(err.message || "Network error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="add-device">
      {/* <h2>Add Device</h2> */}
      <form onSubmit={handleSubmit} className="add-device-form">
        <label>IMEI</label>
        <input
          value={imei}
          onChange={(e) => setImei(e.target.value.replace(/[^0-9]/g, ''))}
          placeholder="Numeric IMEI"
        />

        <label>Device Name</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Truck 12"
        />

        <label>Device Type</label>
        {/* <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="assets">Assets</option>
          <option value="vehicle">Vehicle</option>
          <option value="personal">Personal</option>
          <option value="pet">Pet</option>
        </select> */}

        <div className="add-device-dropdown">
          <FilterDropdown
            value={type}
            onChange={setType}
            options={[
              { value: 'assets', label: 'Assets' },
              { value: 'vehicle', label: 'Vehicle' },
              { value: 'personal', label: 'Personal' },
              { value: 'pet', label: 'Pet' }
            ]}
          />
        </div>

        <div className="actions">
          <button type="submit" className="btn primary" disabled={loading}>
            {loading ? 'Adding...' : 'Add Device'}
          </button>
        </div>
      </form>
    </div>
  );
}
